import React, { useEffect, useState } from 'react';

import SquadSemiBoldText from '../../../../../../../components/Text/SquadSemiBoldText';
import { getFoodifoxDataLazy } from '../../../../../../../lib/axios/FoodifoxDataAPI';
import { ParcelUserName } from '../../../../../../../lib/types';
import SquadRegularText from '../../../../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../../../../components/Text/PingFangRegularText';
import { getWindowWidth } from '../../../../../../../lib/utils/utils';
import ConfirmUserModal from '../ConfirmUserModal';

const SearchName: React.FC<Props> = ({
  isEnglish,
  searchText,
  cabId,
  selectUserCallback,
}) => {
  const [selectUser, setSelectUser] = useState<{ userId: number; userName: string; roomNo: string; phoneNumber: string; registerAddress: string }>();
  const [search] = getFoodifoxDataLazy<ParcelUserName[]>('/fox3PDParcelUser/searchByName');
  const [data, setData] = useState<ParcelUserName[]>();

  useEffect(() => {
    if (searchText != null && searchText.trim().length > 2) {
      search({
        param: {
          registerCabId: cabId,
          keyWord: searchText,
        },
        onError() {
          setData([]);
        },
        onCompleted(nameData) {
          setData(nameData);
        },
      });
    }
    else {
      setData(undefined);
    }
  }, [searchText]);

  if (data != null && data.length === 0) {
    return (
      <>
        {
          isEnglish ? (
            <SquadRegularText color={'#F44336'} lineHeight={18} textAlign={'center'} marginTop={10} marginBottom={10}>
              No registered resident found.
            </SquadRegularText>
          ) : (
            <PingFangRegularText color={'#F44336'} lineHeight={18} textAlign={'center'} marginTop={10} marginBottom={10}>
              未找到已注册的收件人
            </PingFangRegularText>
          )
        }
      </>
    );
  }

  const nameItem = (nameVO: ParcelUserName) => {
    const prefix = nameVO.userName?.substring(0, (searchText || '').length);
    const suffix = nameVO.userName?.substring((searchText || '').length);
    return (
      <div
        style={{ marginTop: 13 }}
        onClick={() => {
          setSelectUser({
            userId: nameVO.userId,
            userName: nameVO.userName || '',
            roomNo: nameVO.roomNo || '',
            registerAddress: nameVO.registerAddress || '',
            phoneNumber: nameVO.phoneNumber ? nameVO.phoneNumber + '' : '',
          });
        }}
      >
        <SquadSemiBoldText fontSize={18}>
          <span style={{ color: '#00B595' }}>{prefix}</span>
          {suffix}
        </SquadSemiBoldText>
        <SquadRegularText color={'#8D969C'} fontSize={16} marginTop={10}>
          Unit {nameVO.roomNo}
        </SquadRegularText>
        <div style={{ height: 1, backgroundColor: '#11202B', opacity: 0.1, marginTop: 9 }} />
      </div>
    );
  };

  return (
    <>
      {
        selectUser && (
          <ConfirmUserModal
            onClose={() => setSelectUser(undefined)}
            isEnglish={isEnglish}
            userName={selectUser.userName}
            roomNo={selectUser.roomNo}
            location={selectUser.registerAddress}
            callback={() => {
              selectUserCallback(selectUser.userId, selectUser.userName, selectUser.phoneNumber);
              setSelectUser(undefined);
            }}
          />
        )
      }
      <div style={{ marginTop: 15 }}>
        {
          (data || []).map((nameVO) => {
            return (
              <div key={nameVO.userId + '-' + nameVO.userName} style={{ width: getWindowWidth() - 50 }}>
                {nameItem(nameVO)}
              </div>
            );
          })
        }
      </div>
    </>
  );
};

export interface Props {
  isEnglish: boolean;
  cabId: number;
  searchText?: string;
  selectUserCallback: (userId: number, userName: string, phoneNumber: string) => void;
}

export default SearchName;
